import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { isSameDay } from 'date-fns';
import { Controller, useFormContext } from 'react-hook-form';
import { Badge, Box, DatePicker } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './DateRow.module.scss';
export const DateRow = (param)=>{
    let { name, label, compactInput, upcomingInvoiceContext, invoiceDraftDates, highlightDays, highlightTooltip, minDate, maxDate, excludeDates, bi, testId } = param;
    const { t: billClientModalTexts } = useLocaleKeys('components.billClientModal');
    const { control, setValue } = useFormContext();
    const firstInvoiceDraftDate = invoiceDraftDates[0];
    const getDayMeta = (day)=>{
        if (firstInvoiceDraftDate != null && isSameDay(day, firstInvoiceDraftDate)) {
            return {
                event: true,
                eventVariant: 'fill',
                tooltip: billClientModalTexts.upcomingInvoiceTooltip()
            };
        }
        if (highlightDays === null || highlightDays === void 0 ? void 0 : highlightDays.some((highlighted)=>isSameDay(day, highlighted))) {
            return {
                event: true,
                eventVariant: 'dot',
                tooltip: highlightTooltip
            };
        }
        return null;
    };
    const shouldDisableDate = excludeDates != null && excludeDates.length > 0 ? (day)=>excludeDates.some((excluded)=>isSameDay(day, excluded)) : undefined;
    const actions = firstInvoiceDraftDate != null ? [
        {
            label: billClientModalTexts.selectUpcomingInvoiceDate(),
            onClick: ()=>setValue(name, firstInvoiceDraftDate, {
                    shouldValidate: true
                })
        }
    ] : undefined;
    const inputBadge = upcomingInvoiceContext != null ? /*#__PURE__*/ _jsx(Badge, {
        skin: "primary",
        rounded: true,
        className: styles.upcomingBadge,
        children: upcomingInvoiceContext.badge
    }) : undefined;
    const helperText = upcomingInvoiceContext === null || upcomingInvoiceContext === void 0 ? void 0 : upcomingInvoiceContext.helperText;
    return /*#__PURE__*/ _jsx(Box, {
        testId: "".concat(testId, "-row"),
        className: cn(styles.root, {
            [styles.compact]: compactInput
        }),
        children: /*#__PURE__*/ _jsx(Controller, {
            control: control,
            name: name,
            render: (param)=>{
                let { field } = param;
                var _field_value;
                return /*#__PURE__*/ _jsx(DatePicker, {
                    label: label,
                    value: (_field_value = field.value) !== null && _field_value !== void 0 ? _field_value : null,
                    onChange: field.onChange,
                    minDate: minDate,
                    maxDate: maxDate,
                    shouldDisableDate: shouldDisableDate,
                    getDayMeta: getDayMeta,
                    actions: actions,
                    helperText: helperText,
                    inputBadge: inputBadge,
                    popperClassName: styles.calendarPopper,
                    bi: bi,
                    testId: testId
                });
            }
        })
    });
};
